module.exports = __webpack_public_path__ + "static/downloable/endoso_prestamos.cda4552.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loans/endoso_prestamos.pdf
// module id = d1/A
// module chunks = 1